import { PaymentType } from '@domgen/dgx-fe-common';
import { CheckoutDirectDebitAccountDetails } from './checkout-direct-debit-account-details.interface';
import { CheckoutDirectDebitIbanAccountDetails } from './checkout-direct-debit-iban-account-details.interface';

export interface CheckoutDirectDebitPaymentDetails {
  directDebitDetails?:
    | CheckoutDirectDebitAccountDetails
    | CheckoutDirectDebitIbanAccountDetails;
  paymentType: PaymentType.DirectDebit;
  preferredPaymentDay: number;
  directDebitPaymentToken?: string;
}
